import { Navigate, Outlet } from 'react-router-dom';
import { useIsAdmin } from '../../hooks/usePermissions';

/**
 * Route-level guard that restricts access to admin users only.
 * For fine-grained per-feature control inside admin routes, use <PermissionGuard />.
 */
export function AdminGuard() {
  const adminAccess = useIsAdmin();
  if (!adminAccess) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}
